<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <div id="pass47">
      <v-card class="ep-rechner-box">
        <v-col cols="12" class="p-0">
          <div class="v-card__title p-0">
            <h2 class="v-card--head--title">
              {{ selectedLang.FirstTrainTile27 }}
            </h2>
          </div>
        </v-col>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <div class="v-card--msg">
                <h2 class="ep-rechner-h2 pb-0">
                  {{ FirstTrainTile28 }}
                </h2>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="strRail">
            <v-col cols="12">
              <v-alert dense type="warning">
                {{ strRailwayText }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <a class="text-decoration-none pl-1" @click="secAlert = !secAlert">
                {{ selectedLang.FirstTrainTile20 }}
              </a><v-alert v-if="secAlert" :value="secAlert" border="top" color="primary" colored-border
                transition="scale-transition" class="text-center">
                <p v-html="selectedLang.FirstTrainTile14"></p>
              </v-alert></v-col>
            <v-col cols="12" sm="6" class="pt-0 pb-2">
              <v-text-field class="pt-0" v-model="bookingCode" :rules="bCRules" :disabled="pass47"
                :label="selectedLang.FirstTrainTile2" :hint="selectedLang.FirstTrainTile3" required></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row v-if="selectedDiv == '47'">
            <v-col cols="12">
              <v-btn v-if="!pass47" id="confirm-data-fl" block @click="validate()" :disabled="pass47"
                class="btn-ep-next-step">
                {{ selectedLang.FirstTrainTile29 }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="selectedDiv != '47' && !noChange">
            <v-col cols="12">
              <v-btn v-if="pass47 && !noChange" block class="btn-ep-back-to" @click="backToSpecificTile('47')">{{
                selectedLang.AdditionalTrainTile15 }}</v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </v-form>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "BookingCodeTile",
  data: function () {
    return {
      bookingCode: "",
      travelerName: "",
      valid: false,
      fromStart: false,
      inBC: "",
      hasAirl: "",
      strRail: false,
      strRailwayText: "",
      loading: false,
      alert: false,
      secAlert: false,
      pgValue: 0,
      pgQuery: false,
      pgShow: true,
      pgInterval: 0,
      showStrCB: false,
      mandaKIT: false,
      kiofTicket: "",
      price: 0,
      FirstTrainTile28: this.$store.state.selectedLang.FirstTrainTile28,
      kiofTicketValues: [
        {
          text: this.$store.state.selectedLang.FirstFlightTileVx2,
          valN: "flexpreis",
        },
        {
          text: this.$store.state.selectedLang.FirstFlightTileVx3,
          valN: "sparpreis",
        },
        {
          text: this.$store.state.selectedLang.FirstFlightTileVx4,
          valN: "supersparpreis",
        },
        {
          text: this.$store.state.selectedLang.FirstFlightTileVx5,
          valN: "sonstiges",
        },
      ],
    };
  },
  computed: {
    ...mapState([
      "kiofCla",
      "progress",
      "selectedDiv",
      "selectedLang",
      "dataTrain",
      "pass47",
      "bCRules",
      "tNRules",
      "futureRide",
    ]),
  },
  watch: {
    bookingCode() {
      this.bookingCode = this.bookingCode.replace(" ", "");
      if (this.bookingCode.length >= 2) {
        if (this.bookingCode.match(/(RB|IC|ICE|ME|NWB|EC|RE)\d+/gi)) {
          this.strRail = true;
        } else {
          this.strRail = false;
        }
      } else {
        this.strRail = false;
      }
    },
  },
  mounted: function () {
    this.strRailwayText = this.$store.state.selectedLang.FirstTrainTile15;
    if(this.futureRide){
      this.FirstTrainTile28 = this.$store.state.selectedLang.FirstTrainTile28a;
    }
  },
  methods: {
    ...mapActions([
      "setSelectedDiv",
      "backToSpecificTile",
      "setVar",
      "getRailData",
      "goToStep",
      "killRun",
    ]),
    restart() {
      this.killRun({ vm: this });
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+.?\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    async validate() {
      this.bookingCode = this.bookingCode.toUpperCase().trim();
      if (this.$refs.form.validate()) {
        this.dataTrain.bookingCode = this.bookingCode;
        this.setVar({ pos: "pass47", val: true });
        this.setSelectedDiv("40");
        this.goToStep({ vm: this, val: this.selectedDiv });
      }
      this.$gtag.event("6c. Buchungscode eingegeben", {
        event_category: "Rechner",
        event_label: "6c. Buchungscode eingegeben",
      });
    },
  },
};
</script>
